import type { CreditRangeEnum } from '@cc-shopping/contracts/credit-cards-page/roundup/utils';
import { Box, Checkbox } from '@mui/material';
import { memo } from 'react';
import { useOffersFilterStore } from 'src/features/roundup-filters/store/Context';
import type {
  AvailableOffersCounts,
  OffersFilterStoreState,
} from 'src/features/roundup-filters/store/types';
import { useShallow } from 'zustand/shallow';
import { Count } from './Count';

export const CheckboxWithCount = memo(
  ({
    id,
    selectedValues,
    value,
    updateValue,
  }: {
    id: keyof AvailableOffersCounts;
    selectedValues: string[];
    value: string | CreditRangeEnum;
    updateValue: (name: string[]) => void;
  }) => {
    const { availableOffersCount } = useOffersFilterStore(
      useShallow((state: OffersFilterStoreState) => ({
        availableOffersCount: state.availableOffersCount,
      })),
    );
    const count =
      id === 'creditRange'
        ? availableOffersCount?.[id]?.[value as CreditRangeEnum]
        : availableOffersCount?.[id]?.[value];

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Count count={count} />
        <Checkbox
          name={id}
          value={value}
          disabled={count === 0}
          aria-checked={selectedValues.includes(value)}
          checked={selectedValues.includes(value)}
          onChange={(_, checked) =>
            updateValue(
              checked ? [...selectedValues, value] : selectedValues.filter(v => v !== value),
            )
          }
          disableRipple
          checkedIcon={
            <span
              className="mask-icon mask-icon-checkbox-outlined"
              style={{
                width: '18px',
                height: '18px',
                borderRadius: '4px',
              }}
            />
          }
          sx={{
            padding: 0,
            color: 'neutral.lighter',
            '& .MuiSvgIcon-root': {
              height: '18px',
              width: '18px',
            },
            '&.Mui-disabled .MuiSvgIcon-root': {
              color: 'neutral.lightest',
            },
          }}
        />
      </Box>
    );
  },
);
